import { render } from "./LoginRootCaptchaEsp.vue?vue&type=template&id=5e793947"
import script from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"
export * from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__